<div class="form-group-planetun" [formGroup]="formGroup">
    <label [for]="name">{{title}}</label>
    <input (keypress)="numberOnly($event)" id="{{name}}" [disabled] autocomplete="off" [maxlength]="length" [value]="value ? value : ''" [mask]="mask ? mask : ''" [validation]="maskValidation" [readonly]="readonly" [class.readonly]="readonly" 
    [type]="type ? type : 'text'" [name]="name" [formControlName]="controlName" 
    [placeholder] ="placeholder"/>
    <app-error-field [control]="formControl"></app-error-field>
</div>